﻿import './sections.css'

const CARDS = [
  {
    icon: '👤', iconBg: 'rgba(201,168,76,0.2)',
    topColor: '#c9a84c', numBg: '#c9a84c', numColor: '#0e1820', num: '1',
    labelColor: '#e0bc6e', label: 'Hire Talent',
    accentColor: '#c9a84c', name: 'SmartHire',
    desc: "Conversational AI interviews that adapt to each candidate's answers — evaluating how they think, not just what they say.",
    features: [
      'Adaptive follow-up questions',
      'Competency-based scoring',
      'AI-driven coding interviews that evaluate real problem-solving ability, not just theoretical knowledge.',
    ],
  },
  {
    icon: '📈', iconBg: 'rgba(167,139,250,0.2)',
    topColor: '#a78bfa', numBg: '#a78bfa', numColor: '#fff', num: '2',
    labelColor: '#c4b5fd', label: 'Develop Talent',
    accentColor: '#a78bfa', name: 'SmartDevelop',
    desc: 'AI career readiness assessments that measure employee readiness for their next role and generate a personalized development roadmap.',
    features: [
      'Role readiness scoring',
      'Strengths & gap analysis',
      '70/20/10 development plans',
    ],
  },
  {
    icon: '✅', iconBg: 'rgba(34,211,238,0.15)',
    topColor: '#22d3ee', numBg: '#22d3ee', numColor: '#0e1820', num: '3',
    labelColor: '#67e8f9', label: 'Measure Talent',
    accentColor: '#22d3ee', name: 'SmartAssess',
    desc: "Conversational competency assessments that measure what employees actually know — not just what training they completed.",
    features: [
      'Post-training validation',
      'Workforce skill gap mapping',
      'Real training ROI data',
    ],
  },
  {
    icon: '💬', iconBg: 'rgba(52,211,153,0.15)',
    topColor: '#34d399', badge: 'EARLY ACCESS',
    labelColor: '#6ee7b7', label: 'Support Talent',
    accentColor: '#34d399', name: 'SmartAssist',
    desc: 'AI assistant for company knowledge — instant answers from internal policies and documentation, with source document references.',
    features: [
      'Instant policy answers',
      'Source document citations',
      '24/7 on any device',
    ],
  },
]

const BENEFITS = [
  { icon: '🔗', color: '#c9a84c',  title: 'Unified Intelligence',    desc: 'One AI knows what was learned in the interview, what training was completed, and what gaps still exist.' },
  { icon: '🔄', color: '#a78bfa',  title: 'Continuous Improvement',  desc: 'Every interaction feeds the intelligence loop, making every assessment more accurate and personalized over time.' },
  { icon: '🚫', color: '#22d3ee',  title: 'No Data Silos',           desc: 'Replace 5–7 disconnected tools with one platform. All talent data flows seamlessly across hiring, development, assessment, and support.' },
]

export default function PlatformSection() {
  return (
    <section id="platform" className="platform-section-dark">
      <div className="container">

        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: '0.6rem', background: 'rgba(201,168,76,0.15)', border: '1px solid rgba(201,168,76,0.3)', borderRadius: '20px', padding: '0.4rem 1.1rem', marginBottom: '1.5rem' }}>
            <span style={{ width: '7px', height: '7px', background: '#c9a84c', borderRadius: '50%', display: 'inline-block' }}/>
            <span style={{ fontSize: '0.82rem', fontWeight: 700, color: '#e0bc6e', letterSpacing: '0.08em', textTransform: 'uppercase' }}>The Platform</span>
          </div>
          <h2 style={{ fontSize: '2.75rem', fontWeight: 800, color: 'white', marginBottom: '1rem', letterSpacing: '-0.02em' }}>One Conversational AI Engine</h2>
          <p style={{ fontSize: '1.15rem', color: 'rgba(255,255,255,0.7)', maxWidth: '600px', margin: '0 auto 1rem' }}>Four interconnected talent intelligence applications. One unified platform. Zero data silos.</p>
          <p style={{ fontSize: '1rem', color: 'rgba(255,255,255,0.65)', maxWidth: '720px', margin: '0 auto', lineHeight: 1.7 }}>Each module works independently but becomes significantly more powerful when used together — creating a continuous intelligence loop across the employee lifecycle.</p>
        </div>

        {/* 4 Product Cards */}
        <div className="platform-cards">
          {CARDS.map(c => (
            <div key={c.name} className="platform-card" style={{ borderTop: `4px solid ${c.topColor}` }}>
              <div className="platform-card-top">
                <div className="platform-card-icon-wrap" style={{ background: c.iconBg }}>{c.icon}</div>
                {c.num
                  ? <div className="platform-card-num" style={{ background: c.numBg, color: c.numColor }}>{c.num}</div>
                  : <div style={{ background: '#c9a84c', color: '#1c2b3a', fontSize: '0.6rem', fontWeight: 800, letterSpacing: '0.06em', padding: '0.25rem 0.6rem', borderRadius: '20px', whiteSpace: 'nowrap' }}>{c.badge}</div>
                }
              </div>
              <div style={{ fontSize: '0.72rem', fontWeight: 700, color: c.labelColor, letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: '0.4rem' }}>{c.label}</div>
              <h3 style={{ fontSize: '1.4rem', fontWeight: 800, color: 'white', marginBottom: '0.75rem' }}>{c.name}</h3>
              <p style={{ fontSize: '0.9rem', color: 'rgba(255,255,255,0.65)', lineHeight: 1.65, marginBottom: '1.25rem' }}>{c.desc}</p>
              <div style={{ borderTop: '1px solid rgba(255,255,255,0.1)', paddingTop: '1rem', display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
                {c.features.map(f => (
                  <div key={f} style={{ fontSize: '0.8rem', color: 'rgba(255,255,255,0.6)', display: 'flex', alignItems: 'flex-start', gap: '0.5rem' }}>
                    <span style={{ color: c.accentColor, flexShrink: 0 }}>✓</span>{f}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Connecting flow label */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0, margin: '0 0 3.5rem' }}>
          <div style={{ height: '2px', flex: 1, background: 'linear-gradient(90deg,transparent,rgba(201,168,76,0.4))' }}/>
          <div style={{ background: 'rgba(201,168,76,0.12)', border: '1px solid rgba(201,168,76,0.3)', borderRadius: '20px', padding: '0.5rem 1.5rem', whiteSpace: 'nowrap' }}>
            <span style={{ fontSize: '0.82rem', fontWeight: 700, color: '#e0bc6e', letterSpacing: '0.04em' }}>The Talent Intelligence Loop — Hire · Develop · Measure · Support</span>
          </div>
          <div style={{ height: '2px', flex: 1, background: 'linear-gradient(90deg,rgba(201,168,76,0.4),transparent)' }}/>
        </div>

        {/* 3 Benefit pillars */}
        <div className="platform-benefits-grid">
          {BENEFITS.map(b => (
            <div key={b.title} className="platform-benefit" style={{ borderLeftColor: b.color }}>
              <div className="platform-benefit-icon">{b.icon}</div>
              <h4>{b.title}</h4>
              <p>{b.desc}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
  )
}
